import { useState } from 'react';

import { StructuredSourceSelector } from '../StructuredFilter/components/StructuredSourceSelector';

export const TreeTest = () => {
  const [values, setValues] = useState<FilterKeyValue[]>([]);

  return (
    <div className="flex flex-col gap-4 w-100">
      <StructuredSourceSelector values={values} onChange={setValues} />
    </div>
  );
};
